import { StoreCalendarType } from 'types/storeCalendar'
import { Action, Dispatch } from 'redux'
import { saveStoreCalendarsConfirmAction } from 'reducks/confirm/actions'
import { push } from 'connected-react-router'
import { fetchCheckoutsByDate } from 'repos/checkout'
import { State } from 'index'

const saveStoreCalendarsConfirm = (store_calendars: StoreCalendarType[], page: 'close' | 'open') => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const storeRef = getState().auth.store_ref
    const temporaryClosedDates = store_calendars.filter((store_calendar) => store_calendar.status === 'close')
    const ret = await Promise.all(
      temporaryClosedDates.map((temporaryClosedDate) =>
        fetchCheckoutsByDate({
          storeRef,
          date: temporaryClosedDate.date,
          status: ['succeeded', 'requires_capture'],
          types: ['daily', 'preorder'],
        })
      )
    )
    const checkouts = ret.flat()
    if (checkouts.length > 0) {
      alert('注文を受け付けている日付は臨時休業日に設定できません。')
      return
    }
    dispatch(saveStoreCalendarsConfirmAction(store_calendars))
    dispatch(push(`/account/settings/${page}/confirm`))
  }
}

export default saveStoreCalendarsConfirm
